import { styled } from 'styled-components'
import HomePageVideo from '../HomePageVideo/HomePageVideo'
import {
  onLargeScreen,
  onMediumScreen,
  onSmallScreen,
  onXXLargeScreen,
} from 'mixtiles-web-common'

export const Video = styled(HomePageVideo)`
  height: 72vh;
  overflow: hidden;
`
export const TitleWrapper = styled.div`
  z-index: 2;
  padding: 44px 10px;
  height: 100%;
  background-image: linear-gradient(
    rgba(0, 0, 0, 0.18) 44%,
    rgba(0, 0, 0, 0) 73%
  );
  background-attachment: scroll;

  ${onMediumScreen()} {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 28px;
  }

  ${onXXLargeScreen()} {
    transform: scale(1.25);
    transform-origin: center;
  }
`

export const TitleText = styled.h1`
  text-align: center;
  font-size: 12vw;
  line-height: 1.1;
  font-weight: 700;
  color: ${({ theme }) => theme.colors.white};
  margin: 0;
  white-space: pre-line;

  ${onSmallScreen()} {
    font-size: 50px;
  }

  ${onMediumScreen()} {
    line-height: 70px;
    font-weight: 600;
    width: 100%;
    font-size: 68px;
  }

  ${onLargeScreen()} {
    white-space: unset;
  }
`

export const Cta = styled.button`
  ${onMediumScreen()} {
    color: white;
    font-size: 20px;
    font-weight: 700;
    border-radius: 15px;
    background: rgba(231, 216, 225, 0.3);
    backdrop-filter: blur(40px);
    padding: 20px 40px;
    outline: none;
    border: none;
    cursor: pointer;
    transition: all 0.2s;

    &:hover {
      background: rgba(231, 216, 225, 0.7);
      color: ${({ theme }) => theme.colors.primaryAccent};
      backdrop-filter: blur(60px);
      transform: scale(0.97);
    }
  }
`

export const ChristmasImage = styled.img`
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  transform: translateY(1px);
  ${onMediumScreen()} {
    transform: translateY(0);
    width: 460px;
    left: auto;
  }
`
